import React from "react";
import logo from "../../assets/ooklass-white-removebg.png";

import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <footer className="bg-dark text-light pt-2 pb-4">
      <div className="container my-3">
        <div className="row py-2 mb-3 d-flex flex-row align-items-center">
          <div className="col-xl-3 col-lg-3 col-sm-12">
            <img
              className="footer-logo"
              alt="logo"
              width="180"
              height="50"
              src={logo}
            ></img>
          </div>
          <div className="col-xl-7 col-lg-7 col-sm-12">
            <div className="d-flex flex-row ms-auto p-sm-1 p-lg-0 mx-sm-1 footer-links fade-color">
              <Link
                to="/"
                className="nav-item nav-link p-sm-1 mx-2 p-3 footer-link"
              >
                Home
              </Link>
              <Link
                to="aboutus"
                className="nav-item nav-link p-3 mx-2 p-sm-1 footer-link"
              >
                About
              </Link>
              <Link
                to="testimonial"
                className="nav-item nav-link p-3 mx-2 p-sm-1 footer-link"
              >
                Testimonials
              </Link>
              <Link
                to="contactUs"
                className="nav-item nav-link p-3 mx-2 p-sm-1 footer-link"
              >
                Contact Us
              </Link>
            </div>
          </div>
          <div className="col-xl-2 col-lg-2 col-sm-12 d-flex social-links fade-color">
            <ul className="list-inline d-flex flex-row align-items-baseline">
              <li className="list-inline-item mt-4">
                <Link
                  to="https://www.instagram.com/ooklass.in/"
                  target="blank"
                  className="text-decoration-none link-light"
                >
                  <h2>
                    <i className="bi bi-instagram footer-link"></i>
                  </h2>
                </Link>
              </li>
              <li className="list-inline-item p-1">
                <Link
                  to="https://www.google.co.in/maps/place/OOKLASS/@29.8461362,74.0239743,17z/data=!3m1!4b1!4m6!3m5!1s0x39164dae5f40000f:0xa1891036f375771e!8m2!3d29.8461316!4d74.0265492!16s%2Fg%2F11t6rkj8b_"
                  target="blank"
                  className="text-decoration-none link-light"
                >
                  <h2>
                    <i className="bi bi-geo-alt-fill footer-link"></i>
                  </h2>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div className="row d-flex flex-row">
          <div className="pt-3 pb-4">
            <div className="container">
              <div className="row justify-content-between">
                <div className="col-xl-3 col-lg-3 col-sm-6">
                  <div className="mb-3">
                    <div>
                      <h2 className="fs-3 p-3 fw-bold text-align-left">
                        About Us
                      </h2>
                    </div>
                    <div className="fade-color">
                      <p className="fade-color fs-6 p-3">
                        We are a leading provider of academic tutoring services,
                        specializing in personalized instruction and academic
                        support for students of all ages and skill levels. Our
                        experienced tutors are passionate about helping students
                        reach their full potential and achieve academic success.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-sm-6">
                  <div className="mb-3">
                    <div>
                      <h2 className="fs-3 p-3 fw-bold">Contact Us</h2>
                    </div>
                    <div className="fade-color fs-6 p-3 mt-1">
                      <i className="bi bi-buildings">
                        {" "}
                        <span>
                          Ward no.27, Near Water works
                          <br />
                          Lalgarh Jattan , SGNR - 335037
                        </span>
                      </i>
                      <br />
                      <i className="bi bi-telephone-fill"> +91-7665873094</i>
                      <br />
                      <i className="bi bi-telephone-fill"> +91-7976408775</i>
                      <br />
                      <i className="bi bi-envelope-at-fill">
                        <Link
                          className="text-decoration-none fade-color footer-link"
                          to="mailto:ooklass07@gmail.com"
                        >
                          {" "}
                          ooklass07@gmail.com
                        </Link>
                      </i>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-sm-6">
                  <div className="mb-3">
                    <div>
                      <h2 className="fs-3 p-3 fw-bold">Our Services</h2>
                    </div>
                    <div className="fade-color fs-6 p-2">
                      <Link
                        to="/contactUs"
                        className="nav-item nav-link p-2 footer-link"
                      >
                        Submit Your Query
                      </Link>
                      <Link
                        to="/login"
                        className="nav-item nav-link p-2 footer-link"
                      >
                        Student Login
                      </Link>
                      <Link
                        to="/login"
                        className="nav-item nav-link p-2 footer-link"
                      >
                        Tutor Login
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-sm-6">
                  <div className="mb-3">
                    <div>
                      <h2 className="fs-3 p-3 fw-bold text-align-left">
                        Our Vision
                      </h2>
                    </div>
                    <div className="fade-color">
                      <p className="fade-color fs-6 p-3">
                        Our vision is to provide the best education to all
                        students in need, ensuring every student has the
                        opportunity to reach their full potential through
                        high-quality tutoring and personalized support.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row fade-color">
          <div className="col-md-7">
            <p><Link className="nav-link footer-link" to="/privacyPolicy"> Privacy Policy </Link>  &copy; 2023 OOKlass. All rights reserved.</p> 
          </div>
            
          <div className="col-md-5">
            <p>
              For technical support write us to:{" "}
              <i className="bi bi-envelope-at-fill">
                <Link
                  to="mailto:ooklass07@gmail.com"
                  className="text-decoration-none fade-color footer-link"
                >
                  {" "}
                  ooklass07@gmail.com
                </Link>
              </i>{" "}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
